import React from 'react';
import { Breadcrumb, BreadcrumbItem } from '../ui/Breadcrumb';
interface PageHeaderProps {
  title: string;
  description?: string;
  breadcrumbs?: BreadcrumbItem[];
  metadata?: React.ReactNode;
  primaryAction?: React.ReactNode;
  secondaryActions?: React.ReactNode;
}
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  breadcrumbs,
  metadata,
  primaryAction,
  secondaryActions
}) => {
  return <div className="mb-6" data-id="element-103">
      {breadcrumbs && <Breadcrumb items={breadcrumbs} className="mb-4" data-id="element-104" />}

      <div className="flex flex-col md:flex-row md:items-start justify-between gap-4" data-id="element-105">
        <div data-id="element-106">
          <h1 className="text-2xl font-bold text-text-primary tracking-tight" data-id="element-107">
            {title}
          </h1>
          {description && <p className="text-sm text-text-secondary mt-1 max-w-2xl" data-id="element-108">
              {description}
            </p>}
          {metadata && <div className="mt-3 flex items-center gap-3 text-sm text-text-tertiary" data-id="element-109">
              {metadata}
            </div>}
        </div>

        {(primaryAction || secondaryActions) && <div className="flex items-center gap-3 shrink-0" data-id="element-110">
            {secondaryActions}
            {primaryAction}
          </div>}
      </div>
    </div>;
};